import React, {Component} from 'react';

import {connect} from 'react-redux';
import * as actionTypes from '../../store/actions';
import * as actionCreators from '../../store/actionCreators';
import Config from 'Config';
import axios from "axios";
import AdvisorAuth from "../../services/AdvisorAuth";

class Mmfa extends Component {

    componentWillReceiveProps(nextProps) {
        if (nextProps.isAuthorized) {
            // this.props.history.push("/annuityCalculator");
            this.props.history.push("/introduction");
        }
    }

    componentDidMount() {
        console.log(this.props.isAuthorized);

        if (!this.props.isAuthorized) {
            this.props.login();
            this.props.setCompanyName();
            AdvisorAuth.setInstitute("MMFA");
        }
    }

    render() {
        return (
            <div>
                You are not authorized to view this page.
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthorized: state.globalState.isAuthorized
    };
};


const mapDispatchToProps = (dispatch) => {
    return {
        login: () => dispatch(actionCreators.loginAsCompany(
            "mmfa@mmfa.com",
            "MassMutual",
            "Financial Advisors",
            "Mass Mutual Financial Advisors",
        5)),
        setCompanyName: () => dispatch({
            type: actionTypes.SET_COMPANY_NAME,
            value: "MMFA"
        })
    }
};

export default connect(mapStateToProps, mapDispatchToProps) (Mmfa);


// WEBPACK FOOTER //
// ./src/containers/Start/Mmfa.js